angular.module('zc')
  .component('zcSiteReportKpiBox', {
    templateUrl: '/templates/projects.site_reports/kpi_box.html',
    bindings: { project: '<' },
    controller: zcSiteReportKpiBoxController,
  });

zcSiteReportKpiBoxController.$inject = ['$scope'];
function zcSiteReportKpiBoxController($scope) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project) return;
    vm.invoicePrice = project.thisMonthInvoice ? project.thisMonthInvoice.invoice_price_tax_excluded : 0;
    vm.budget = project.max_invoice || project.budget;
    if(vm.budget) vm.achievementRate = vm.invoicePrice / vm.budget;
  });
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.site_reports/kpi_box.controller.js